import axios, { CancelTokenSource } from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';
export const getBusinessLogicConfiguration = (
  obj: any,
  tokenSource?: CancelTokenSource
) => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `dig/business-logic`, {
    params: obj,
  });
};
export const getBusinessLogicConfigurationSqlValidate = (
  obj: Object,
  tokenSource?: CancelTokenSource
) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/business-logic/sql-validation`,
    obj,
    { headers, cancelToken: tokenSource?.token }
  );
};
export const AddBusinessLogicConfiguration = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/business-logic/add`,
    obj,
    { headers }
  );
};

export const EditBusinessLogicConfiguration = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/business-logic/update`,
    obj,
    { headers }
  );
};

export const DeleteBusinessLogicConfiguration = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `dig/business-logic/delete`,
    obj,
    { headers }
  );
};
